import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { MantenedoresContext } from '../context/MantenedoresContext';
import { MANTENEDOR_MODULES_MAP } from '../utils/mantenedorConstants';

/**
 * Hook personalizado para manejar permisos de mantenedores usando el contexto global
 */
export const useMantenedorPermissions = () => {
  const { user: currentUser } = useSelector(state => state.auth);
  const {
    userPermissions,
    loading,
    error
  } = useContext(MantenedoresContext);

  // Verificar si el usuario tiene permisos para un mantenedor específico
  const checkPermission = (mantenedorId) => {
    if (!currentUser?.email) return false;
    if (loading) return false;
    if (error) return false;

    // Excepción para el módulo principal
    if (mantenedorId === 'mantenedores') return true;

    // Usar directamente el id del mantenedor como clave
    return userPermissions && userPermissions.modules &&
      userPermissions.modules[mantenedorId] &&
      userPermissions.modules[mantenedorId].hasAccess;
  };

  // Verificar si el usuario está autenticado
  const isAuthenticated = () => {
    return !!currentUser?.email;
  };

  // Obtener información del usuario actual
  const getCurrentUser = () => {
    return {
      email: currentUser?.email || null,
      displayName: currentUser?.displayName || null,
      uid: currentUser?.uid || null,
      photoURL: currentUser?.photoURL || null
    };
  };

  // Filtrar mantenedores según permisos del usuario
  const filterMantenedoresByPermission = (mantenedoresList) => {
    if (!userPermissions || !userPermissions.modules) return [];
    return mantenedoresList.filter(mantenedor => {
      const tienePermiso = userPermissions.modules[mantenedor.id]?.hasAccess;
      return !!tienePermiso;
    });
  };

  return {
    checkPermission,
    isAuthenticated,
    getCurrentUser,
    filterMantenedoresByPermission,
    currentUser,
    userPermissions,
    permissionsLoading: loading,
    permissionsError: error
  };
};
